import * as React from "react";
import { mergeClasses } from "@fluentui/react-components";
import { SocialIcon } from "react-social-icons";
import { useFormPrimitiveStyles } from "../formPrimitives";
import { REFINED } from "../../risikoanalyseStep/tokens";
import {
  normalizeSocialValue,
  detectSocialPlatform,
  PLACEHOLDERS,
  type SocialPlatform,
} from "../validation";
import { SperrWert } from "../SperrWert";

/**
 * Social-Media-Feld: Plattform-Glyph als Icon, normalisiert beim Blur (URL
 * behalten / https voranstellen). Wenn der eingefügte Link zu einer ANDEREN
 * Plattform gehört, erscheint ein dezenter (nicht blockierender) Hinweis.
 */
export function SocialMediaInput({
  label,
  name,
  platform,
  value,
  onChange,
}: {
  label: string;
  name: string;
  platform: SocialPlatform;
  value: string;
  onChange: (v: string) => void;
}) {
  const s = useFormPrimitiveStyles();
  const [touched, setTouched] = React.useState(false);
  const detected = detectSocialPlatform(value);
  const mismatch = touched && !!value.trim() && !!detected && detected !== platform;

  return (
    <div className={s.field}>
      <label className={s.label} htmlFor={name}>{label}</label>
      <div className={s.inputWrap}>
        <span className={s.inputIcon}>
          <SocialIcon network={platform} as="span" style={{ height: 18, width: 18 }} />
        </span>
        <input
          id={name}
          name={name}
          className={mergeClasses(s.input, s.inputWithIcon)}
          value={value}
          placeholder={PLACEHOLDERS.social[platform]}
          onChange={(e) => onChange(e.target.value)}
          onBlur={() => {
            setTouched(true);
            const n = normalizeSocialValue(platform, value);
            if (n !== value) onChange(n);
          }}
        />
        <SperrWert />
      </div>
      {mismatch && (
        <div style={{ fontSize: "0.8rem", color: REFINED.ink2, marginTop: "2px" }}>
          Dieser Link sieht nach „{detected}" aus – richtiges Feld?
        </div>
      )}
    </div>
  );
}

export default SocialMediaInput;
